module.exports = [
  {
    label: "3D printing",
    category: "General",
    subCategory: "Indoors",
  },
  {
    label: "Acrobatics",
    category: "General",
    subCategory: "Indoors",
  },
  {
    label: "Acting",
    category: "General",
    subCategory: "Indoors",
  },
  {
    label: "Amateur radio",
    category: "General",
    subCategory: "Indoors",
  },
  {
    label: "Animation",
    category: "General",
    subCategory: "Indoors",
  },
  {
    label: "Aquascaping",
    category: "General",
    subCategory: "Indoors",
  },
  {
    label: "Astrology",
    category: "General",
    subCategory: "Indoors",
  },
  {
    label: "Astronomy",
    category: "General",
    subCategory: "Indoors",
  },
  {
    label: "Baking",
    category: "General",
    subCategory: "Indoors",
  },
  {
    label: "Baton twirling",
    category: "General",
    subCategory: "Indoors",
  },
  {
    label: "Blogging",
    category: "General",
    subCategory: "Indoors",
  },
  {
    label: "Building",
    category: "General",
    subCategory: "Indoors",
  },
  {
    label: "Board/tabletop games",
    category: "General",
    subCategory: "Indoors",
  },
  {
    label: "Book discussion clubs",
    category: "General",
    subCategory: "Indoors",
  },
  {
    label: "Book restoration",
    category: "General",
    subCategory: "Indoors",
  },
  {
    label: "Bowling",
    category: "General",
    subCategory: "Indoors",
  },
  {
    label: "Brazilian jiu-jitsu",
    category: "General",
    subCategory: "Indoors",
  },
  {
    label: "Breadmaking",
    category: "General",
    subCategory: "Indoors",
  },
  {
    label: "Bullet journaling",
    category: "General",
    subCategory: "Indoors",
  },
  {
    label: "Cabaret",
    category: "General",
    subCategory: "Indoors",
  },
  {
    label: "Calligraphy",
    category: "General",
    subCategory: "Indoors",
  },
  {
    label: "Candle making",
    category: "General",
    subCategory: "Indoors",
  },
  {
    label: "Candy making",
    category: "General",
    subCategory: "Indoors",
  },
  {
    label: "Car fixing & building",
    category: "General",
    subCategory: "Indoors",
  },
  {
    label: "Card games",
    category: "General",
    subCategory: "Indoors",
  },
  {
    label: "Cheesemaking",
    category: "General",
    subCategory: "Indoors",
  },
  {
    label: "Cleaning",
    category: "General",
    subCategory: "Indoors",
  },
  {
    label: "Clothesmaking",
    category: "General",
    subCategory: "Indoors",
  },
  {
    label: "Coffee roasting",
    category: "General",
    subCategory: "Indoors",
  },
  {
    label: "Collecting",
    category: "General",
    subCategory: "Indoors",
  },
  {
    label: "Coloring",
    category: "General",
    subCategory: "Indoors",
  },
  {
    label: "Computer programming",
    category: "General",
    subCategory: "Indoors",
  },
  {
    label: "Confectionery",
    category: "General",
    subCategory: "Indoors",
  },
  {
    label: "Cooking",
    category: "General",
    subCategory: "Indoors",
  },
  {
    label: "Cosplaying",
    category: "General",
    subCategory: "Indoors",
  },
  {
    label: "Couponing",
    category: "General",
    subCategory: "Indoors",
  },
  {
    label: "Craft",
    category: "General",
    subCategory: "Indoors",
  },
  {
    label: "Creative writing",
    category: "General",
    subCategory: "Indoors",
  },
  {
    label: "Crocheting",
    category: "General",
    subCategory: "Indoors",
  },
  {
    label: "Cross-stitch",
    category: "General",
    subCategory: "Indoors",
  },
  {
    label: "Crossword puzzles",
    category: "General",
    subCategory: "Indoors",
  },
  {
    label: "Cryptography",
    category: "General",
    subCategory: "Indoors",
  },
  {
    label: "Cue sports",
    category: "General",
    subCategory: "Indoors",
  },
  {
    label: "Dance",
    category: "General",
    subCategory: "Indoors",
  },
  {
    label: "Digital arts",
    category: "General",
    subCategory: "Indoors",
  },
  {
    label: "Distro Hopping",
    category: "General",
    subCategory: "Indoors",
  },
  {
    label: "DJing",
    category: "General",
    subCategory: "Indoors",
  },
  {
    label: "Do it yourself",
    category: "General",
    subCategory: "Indoors",
  },
  {
    label: "Drama",
    category: "General",
    subCategory: "Indoors",
  },
  {
    label: "Drawing",
    category: "General",
    subCategory: "Indoors",
  },
  {
    label: "Drink mixing",
    category: "General",
    subCategory: "Indoors",
  },
  {
    label: "Drinking",
    category: "General",
    subCategory: "Indoors",
  },
  {
    label: "Electronic games",
    category: "General",
    subCategory: "Indoors",
  },
  {
    label: "Electronics",
    category: "General",
    subCategory: "Indoors",
  },
  {
    label: "Embroidery",
    category: "General",
    subCategory: "Indoors",
  },
  {
    label: "Experimenting",
    category: "General",
    subCategory: "Indoors",
  },
  {
    label: "Fantasy sports",
    category: "General",
    subCategory: "Indoors",
  },
  {
    label: "Fashion",
    category: "General",
    subCategory: "Indoors",
  },
  {
    label: "Fashion design",
    category: "General",
    subCategory: "Indoors",
  },
  {
    label: "Fishkeeping",
    category: "General",
    subCategory: "Indoors",
  },
  {
    label: "Filmmaking",
    category: "General",
    subCategory: "Indoors",
  },
  {
    label: "Flower arranging",
    category: "General",
    subCategory: "Indoors",
  },
  {
    label: "Fly tying",
    category: "General",
    subCategory: "Indoors",
  },
  {
    label: "Foreign language learning",
    category: "General",
    subCategory: "Indoors",
  },
  {
    label: "Furniture building",
    category: "General",
    subCategory: "Indoors",
  },
  {
    label: "Gaming",
    category: "General",
    subCategory: "Indoors",
  },
  {
    label: "Genealogy",
    category: "General",
    subCategory: "Indoors",
  },
  {
    label: "Gingerbread house making",
    category: "General",
    subCategory: "Indoors",
  },
  {
    label: "Glassblowing",
    category: "General",
    subCategory: "Indoors",
  },
  {
    label: "Graphic design",
    category: "General",
    subCategory: "Indoors",
  },
  {
    label: "Gunsmithing",
    category: "General",
    subCategory: "Indoors",
  },
  {
    label: "Gymnastics",
    category: "General",
    subCategory: "Indoors",
  },
  {
    label: "Hacking",
    category: "General",
    subCategory: "Indoors",
  },
  {
    label: "Herp keeping",
    category: "General",
    subCategory: "Indoors",
  },
  {
    label: "Home improvement",
    category: "General",
    subCategory: "Indoors",
  },
  {
    label: "Homebrewing",
    category: "General",
    subCategory: "Indoors",
  },
  {
    label: "Houseplant care",
    category: "General",
    subCategory: "Indoors",
  },
  {
    label: "Hula hooping",
    category: "General",
    subCategory: "Indoors",
  },
  {
    label: "Humor",
    category: "General",
    subCategory: "Indoors",
  },
  {
    label: "Hydroponics",
    category: "General",
    subCategory: "Indoors",
  },
  {
    label: "Ice skating",
    category: "General",
    subCategory: "Indoors",
  },
  {
    label: "Jewelry making",
    category: "General",
    subCategory: "Indoors",
  },
  {
    label: "Jigsaw puzzles",
    category: "General",
    subCategory: "Indoors",
  },
  {
    label: "Journaling",
    category: "General",
    subCategory: "Indoors",
  },
  {
    label: "Juggling",
    category: "General",
    subCategory: "Indoors",
  },
  {
    label: "Karaoke",
    category: "General",
    subCategory: "Indoors",
  },
  {
    label: "Karate",
    category: "General",
    subCategory: "Indoors",
  },
  {
    label: "Kendama",
    category: "General",
    subCategory: "Indoors",
  },
  {
    label: "Knife making",
    category: "General",
    subCategory: "Indoors",
  },
  {
    label: "Knitting",
    category: "General",
    subCategory: "Indoors",
  },
  {
    label: "Knot tying",
    category: "General",
    subCategory: "Indoors",
  },
  {
    label: "Kombucha brewing",
    category: "General",
    subCategory: "Indoors",
  },
  {
    label: "Lace making",
    category: "General",
    subCategory: "Indoors",
  },
  {
    label: "Lapidary",
    category: "General",
    subCategory: "Indoors",
  },
  {
    label: "Leather crafting",
    category: "General",
    subCategory: "Indoors",
  },
  {
    label: "Lego building",
    category: "General",
    subCategory: "Indoors",
  },
  {
    label: "Lock picking",
    category: "General",
    subCategory: "Indoors",
  },
  {
    label: "Listening to music",
    category: "General",
    subCategory: "Indoors",
  },
  {
    label: "Listening to podcasts",
    category: "General",
    subCategory: "Indoors",
  },
  {
    label: "Machining",
    category: "General",
    subCategory: "Indoors",
  },
  {
    label: "Macrame",
    category: "General",
    subCategory: "Indoors",
  },
  {
    label: "Magic",
    category: "General",
    subCategory: "Indoors",
  },
  {
    label: "Makeup",
    category: "General",
    subCategory: "Indoors",
  },
  {
    label: "Mazes (indoor/outdoor)",
    category: "General",
    subCategory: "Indoors",
  },
  {
    label: "Metalworking",
    category: "General",
    subCategory: "Indoors",
  },
  {
    label: "Model building",
    category: "General",
    subCategory: "Indoors",
  },
  {
    label: "Model engineering",
    category: "General",
    subCategory: "Indoors",
  },
  {
    label: "Nail art",
    category: "General",
    subCategory: "Indoors",
  },
  {
    label: "Needlepoint",
    category: "General",
    subCategory: "Indoors",
  },
  {
    label: "Origami",
    category: "General",
    subCategory: "Indoors",
  },
  {
    label: "Painting",
    category: "General",
    subCategory: "Indoors",
  },
  {
    label: "Palmistry",
    category: "General",
    subCategory: "Indoors",
  },
  {
    label: "Pet adoption & fostering",
    category: "General",
    subCategory: "Indoors",
  },
  {
    label: "Philately",
    category: "General",
    subCategory: "Indoors",
  },
  {
    label: "Photography",
    category: "General",
    subCategory: "Indoors",
  },
  {
    label: "Practical jokes",
    category: "General",
    subCategory: "Indoors",
  },
  {
    label: "Pressed flower craft",
    category: "General",
    subCategory: "Indoors",
  },
  {
    label: "Playing musical instruments",
    category: "General",
    subCategory: "Indoors",
  },
  {
    label: "Poi",
    category: "General",
    subCategory: "Indoors",
  },
  {
    label: "Pottery",
    category: "General",
    subCategory: "Indoors",
  },
  {
    label: "Powerlifting",
    category: "General",
    subCategory: "Indoors",
  },
  {
    label: "Puzzles",
    category: "General",
    subCategory: "Indoors",
  },
  {
    label: "Quilling",
    category: "General",
    subCategory: "Indoors",
  },
  {
    label: "Quilting",
    category: "General",
    subCategory: "Indoors",
  },
  {
    label: "Quizzes",
    category: "General",
    subCategory: "Indoors",
  },
  {
    label: "Radio-controlled model",
    category: "General",
    subCategory: "Indoors",
  },
  {
    label: "Rail transport modeling",
    category: "General",
    subCategory: "Indoors",
  },
  {
    label: "Rapping",
    category: "General",
    subCategory: "Indoors",
  },
  {
    label: "Reading",
    category: "General",
    subCategory: "Indoors",
  },
  {
    label: "Refinishing",
    category: "General",
    subCategory: "Indoors",
  },
  {
    label: "Reiki",
    category: "General",
    subCategory: "Indoors",
  },
  {
    label: "Robot combat",
    category: "General",
    subCategory: "Indoors",
  },
  {
    label: "Rubik's Cube",
    category: "General",
    subCategory: "Indoors",
  },
  {
    label: "Scrapbooking",
    category: "General",
    subCategory: "Indoors",
  },
  {
    label: "Sculpting",
    category: "General",
    subCategory: "Indoors",
  },
  {
    label: "Sewing",
    category: "General",
    subCategory: "Indoors",
  },
  {
    label: "Shoemaking",
    category: "General",
    subCategory: "Indoors",
  },
  {
    label: "Singing",
    category: "General",
    subCategory: "Indoors",
  },
  {
    label: "Sketching",
    category: "General",
    subCategory: "Indoors",
  },
  {
    label: "Skipping rope",
    category: "General",
    subCategory: "Indoors",
  },
  {
    label: "Slot car",
    category: "General",
    subCategory: "Indoors",
  },
  {
    label: "Soapmaking",
    category: "General",
    subCategory: "Indoors",
  },
  {
    label: "Social media",
    category: "General",
    subCategory: "Indoors",
  },
  {
    label: "Spreadsheets",
    category: "General",
    subCategory: "Indoors",
  },
  {
    label: "Stand-up comedy",
    category: "General",
    subCategory: "Indoors",
  },
  {
    label: "Stamp collecting",
    category: "General",
    subCategory: "Indoors",
  },
  {
    label: "Table tennis",
    category: "General",
    subCategory: "Indoors",
  },
  {
    label: "Tarot",
    category: "General",
    subCategory: "Indoors",
  },
  {
    label: "Taxidermy",
    category: "General",
    subCategory: "Indoors",
  },
  {
    label: "Thrifting",
    category: "General",
    subCategory: "Indoors",
  },
  {
    label: "Video editing",
    category: "General",
    subCategory: "Indoors",
  },
  {
    label: "Video game developing",
    category: "General",
    subCategory: "Indoors",
  },
  {
    label: "Video gaming",
    category: "General",
    subCategory: "Indoors",
  },
  {
    label: "Watching movies",
    category: "General",
    subCategory: "Indoors",
  },
  {
    label: "Watching television",
    category: "General",
    subCategory: "Indoors",
  },
  {
    label: "Videography",
    category: "General",
    subCategory: "Indoors",
  },
  {
    label: "Virtual reality",
    category: "General",
    subCategory: "Indoors",
  },
  {
    label: "Waxing",
    category: "General",
    subCategory: "Indoors",
  },
  {
    label: "Weaving",
    category: "General",
    subCategory: "Indoors",
  },
  {
    label: "Weight training",
    category: "General",
    subCategory: "Indoors",
  },
  {
    label: "Welding",
    category: "General",
    subCategory: "Indoors",
  },
  {
    label: "Whittling",
    category: "General",
    subCategory: "Indoors",
  },
  {
    label: "Wikipedia editing",
    category: "General",
    subCategory: "Indoors",
  },
  {
    label: "Winemaking",
    category: "General",
    subCategory: "Indoors",
  },
  {
    label: "Wood carving",
    category: "General",
    subCategory: "Indoors",
  },
  {
    label: "Woodworking",
    category: "General",
    subCategory: "Indoors",
  },
  {
    label: "Worldbuilding",
    category: "General",
    subCategory: "Indoors",
  },
  {
    label: "Writing",
    category: "General",
    subCategory: "Indoors",
  },
  {
    label: "Word searches",
    category: "General",
    subCategory: "Indoors",
  },
  {
    label: "Yo-yoing",
    category: "General",
    subCategory: "Indoors",
  },
  {
    label: "Yoga",
    category: "General",
    subCategory: "Indoors",
  },
  {
    label: "Zumba",
    category: "General",
    subCategory: "Indoors",
  },
  {
    label: "Amusement park visiting",
    category: "General",
    subCategory: "Outdoors",
  },
  {
    label: "Air sports",
    category: "General",
    subCategory: "Outdoors",
  },
  {
    label: "Airsoft",
    category: "General",
    subCategory: "Outdoors",
  },
  {
    label: "Amateur geology",
    category: "General",
    subCategory: "Outdoors",
  },
  {
    label: "Archery",
    category: "General",
    subCategory: "Outdoors",
  },
  {
    label: "Astronomy",
    category: "General",
    subCategory: "Outdoors",
  },
  {
    label: "Backpacking",
    category: "General",
    subCategory: "Outdoors",
  },
  {
    label: "Badminton",
    category: "General",
    subCategory: "Outdoors",
  },
  {
    label: "BASE jumping",
    category: "General",
    subCategory: "Outdoors",
  },
  {
    label: "Baseball",
    category: "General",
    subCategory: "Outdoors",
  },
  {
    label: "Basketball",
    category: "General",
    subCategory: "Outdoors",
  },
  {
    label: "Beekeeping",
    category: "General",
    subCategory: "Outdoors",
  },
  {
    label: "Birdwatching",
    category: "General",
    subCategory: "Outdoors",
  },
  {
    label: "Blacksmithing",
    category: "General",
    subCategory: "Outdoors",
  },
  {
    label: "BMX",
    category: "General",
    subCategory: "Outdoors",
  },
  {
    label: "Board sports",
    category: "General",
    subCategory: "Outdoors",
  },
  {
    label: "Bodybuilding",
    category: "General",
    subCategory: "Outdoors",
  },
  {
    label: "Bonsai",
    category: "General",
    subCategory: "Outdoors",
  },
  {
    label: "Butterfly watching",
    category: "General",
    subCategory: "Outdoors",
  },
  {
    label: "Bus riding",
    category: "General",
    subCategory: "Outdoors",
  },
  {
    label: "Camping",
    category: "General",
    subCategory: "Outdoors",
  },
  {
    label: "Canoeing",
    category: "General",
    subCategory: "Outdoors",
  },
  {
    label: "Canyoning",
    category: "General",
    subCategory: "Outdoors",
  },
  {
    label: "Car riding",
    category: "General",
    subCategory: "Outdoors",
  },
  {
    label: "Caving",
    category: "General",
    subCategory: "Outdoors",
  },
  {
    label: "Composting",
    category: "General",
    subCategory: "Outdoors",
  },
  {
    label: "Cycling",
    category: "General",
    subCategory: "Outdoors",
  },
  {
    label: "Dowsing",
    category: "General",
    subCategory: "Outdoors",
  },
  {
    label: "Driving",
    category: "General",
    subCategory: "Outdoors",
  },
  {
    label: "Farming",
    category: "General",
    subCategory: "Outdoors",
  },
  {
    label: "Fishing",
    category: "General",
    subCategory: "Outdoors",
  },
  {
    label: "Flag football",
    category: "General",
    subCategory: "Outdoors",
  },
  {
    label: "Flower growing",
    category: "General",
    subCategory: "Outdoors",
  },
  {
    label: "Flying",
    category: "General",
    subCategory: "Outdoors",
  },
  {
    label: "Flying disc",
    category: "General",
    subCategory: "Outdoors",
  },
  {
    label: "Foraging",
    category: "General",
    subCategory: "Outdoors",
  },
  {
    label: "Fossicking",
    category: "General",
    subCategory: "Outdoors",
  },
  {
    label: "Freestyle football",
    category: "General",
    subCategory: "Outdoors",
  },
  {
    label: "Gardening",
    category: "General",
    subCategory: "Outdoors",
  },
  {
    label: "Geocaching",
    category: "General",
    subCategory: "Outdoors",
  },
  {
    label: "Ghost hunting",
    category: "General",
    subCategory: "Outdoors",
  },
  {
    label: "Gold prospecting",
    category: "General",
    subCategory: "Outdoors",
  },
  {
    label: "Graffiti",
    category: "General",
    subCategory: "Outdoors",
  },
  {
    label: "Handball",
    category: "General",
    subCategory: "Outdoors",
  },
  {
    label: "Herbalism",
    category: "General",
    subCategory: "Outdoors",
  },
  {
    label: "Herping",
    category: "General",
    subCategory: "Outdoors",
  },
  {
    label: "High-power rocketry",
    category: "General",
    subCategory: "Outdoors",
  },
  {
    label: "Hiking",
    category: "General",
    subCategory: "Outdoors",
  },
  {
    label: "Hobby horsing",
    category: "General",
    subCategory: "Outdoors",
  },
  {
    label: "Hobby tunneling",
    category: "General",
    subCategory: "Outdoors",
  },
  {
    label: "Hooping",
    category: "General",
    subCategory: "Outdoors",
  },
  {
    label: "Horseback riding",
    category: "General",
    subCategory: "Outdoors",
  },
  {
    label: "Hunting",
    category: "General",
    subCategory: "Outdoors",
  },
  {
    label: "Inline skating",
    category: "General",
    subCategory: "Outdoors",
  },
  {
    label: "Jogging",
    category: "General",
    subCategory: "Outdoors",
  },
  {
    label: "Jumping rope",
    category: "General",
    subCategory: "Outdoors",
  },
  {
    label: "Kayaking",
    category: "General",
    subCategory: "Outdoors",
  },
  {
    label: "Kite flying",
    category: "General",
    subCategory: "Outdoors",
  },
  {
    label: "Kitesurfing",
    category: "General",
    subCategory: "Outdoors",
  },
  {
    label: "Lacrosse",
    category: "General",
    subCategory: "Outdoors",
  },
  {
    label: "LARPing",
    category: "General",
    subCategory: "Outdoors",
  },
  {
    label: "Letterboxing",
    category: "General",
    subCategory: "Outdoors",
  },
  {
    label: "Longboarding",
    category: "General",
    subCategory: "Outdoors",
  },
  {
    label: "Martial arts",
    category: "General",
    subCategory: "Outdoors",
  },
  {
    label: "Metal detecting",
    category: "General",
    subCategory: "Outdoors",
  },
  {
    label: "Meteorology",
    category: "General",
    subCategory: "Outdoors",
  },
  {
    label: "Motor sports",
    category: "General",
    subCategory: "Outdoors",
  },
  {
    label: "Mountain biking",
    category: "General",
    subCategory: "Outdoors",
  },
  {
    label: "Mountaineering",
    category: "General",
    subCategory: "Outdoors",
  },
  {
    label: "Museum visiting",
    category: "General",
    subCategory: "Outdoors",
  },
  {
    label: "Mushroom hunting",
    category: "General",
    subCategory: "Outdoors",
  },
  {
    label: "Netball",
    category: "General",
    subCategory: "Outdoors",
  },
  {
    label: "Nordic skating",
    category: "General",
    subCategory: "Outdoors",
  },
  {
    label: "Orienteering",
    category: "General",
    subCategory: "Outdoors",
  },
  {
    label: "Paintball",
    category: "General",
    subCategory: "Outdoors",
  },
  {
    label: "Parkour",
    category: "General",
    subCategory: "Outdoors",
  },
  {
    label: "Photography",
    category: "General",
    subCategory: "Outdoors",
  },
  {
    label: "Podcast hosting",
    category: "General",
    subCategory: "Outdoors",
  },
  {
    label: "Polo",
    category: "General",
    subCategory: "Outdoors",
  },
  {
    label: "Public transport riding",
    category: "General",
    subCategory: "Outdoors",
  },
  {
    label: "Rafting",
    category: "General",
    subCategory: "Outdoors",
  },
  {
    label: "Railway journeys",
    category: "General",
    subCategory: "Outdoors",
  },
  {
    label: "Rappelling",
    category: "General",
    subCategory: "Outdoors",
  },
  {
    label: "Road biking",
    category: "General",
    subCategory: "Outdoors",
  },
  {
    label: "Rock climbing",
    category: "General",
    subCategory: "Outdoors",
  },
  {
    label: "Roller skating",
    category: "General",
    subCategory: "Outdoors",
  },
  {
    label: "Rugby",
    category: "General",
    subCategory: "Outdoors",
  },
  {
    label: "Running",
    category: "General",
    subCategory: "Outdoors",
  },
  {
    label: "Radio-controlled model",
    category: "General",
    subCategory: "Outdoors",
  },
  {
    label: "Sailing",
    category: "General",
    subCategory: "Outdoors",
  },
  {
    label: "Sand art",
    category: "General",
    subCategory: "Outdoors",
  },
  {
    label: "Scouting",
    category: "General",
    subCategory: "Outdoors",
  },
  {
    label: "Scuba diving",
    category: "General",
    subCategory: "Outdoors",
  },
  {
    label: "Sculling",
    category: "General",
    subCategory: "Outdoors",
  },
  {
    label: "Shooting",
    category: "General",
    subCategory: "Outdoors",
  },
  {
    label: "Shopping",
    category: "General",
    subCategory: "Outdoors",
  },
  {
    label: "Shuffleboard",
    category: "General",
    subCategory: "Outdoors",
  },
  {
    label: "Skateboarding",
    category: "General",
    subCategory: "Outdoors",
  },
  {
    label: "Skiing",
    category: "General",
    subCategory: "Outdoors",
  },
  {
    label: "Skimboarding",
    category: "General",
    subCategory: "Outdoors",
  },
  {
    label: "Skydiving",
    category: "General",
    subCategory: "Outdoors",
  },
  {
    label: "Slacklining",
    category: "General",
    subCategory: "Outdoors",
  },
  {
    label: "Snowboarding",
    category: "General",
    subCategory: "Outdoors",
  },
  {
    label: "Snowmobiling",
    category: "General",
    subCategory: "Outdoors",
  },
  {
    label: "Snowshoeing",
    category: "General",
    subCategory: "Outdoors",
  },
  {
    label: "Soccer",
    category: "General",
    subCategory: "Outdoors",
  },
  {
    label: "Stone skipping",
    category: "General",
    subCategory: "Outdoors",
  },
  {
    label: "Sun bathing",
    category: "General",
    subCategory: "Outdoors",
  },
  {
    label: "Surfing",
    category: "General",
    subCategory: "Outdoors",
  },
  {
    label: "Survivalism",
    category: "General",
    subCategory: "Outdoors",
  },
  {
    label: "Swimming",
    category: "General",
    subCategory: "Outdoors",
  },
  {
    label: "Taekwondo",
    category: "General",
    subCategory: "Outdoors",
  },
  {
    label: "Tai chi",
    category: "General",
    subCategory: "Outdoors",
  },
  {
    label: "Tennis",
    category: "General",
    subCategory: "Outdoors",
  },
  {
    label: "Topiary",
    category: "General",
    subCategory: "Outdoors",
  },
  {
    label: "Tourism",
    category: "General",
    subCategory: "Outdoors",
  },
  {
    label: "Thru-hiking",
    category: "General",
    subCategory: "Outdoors",
  },
  {
    label: "Trade fair visiting",
    category: "General",
    subCategory: "Outdoors",
  },
  {
    label: "Travel",
    category: "General",
    subCategory: "Outdoors",
  },
  {
    label: "Urban exploration",
    category: "General",
    subCategory: "Outdoors",
  },
  {
    label: "Vacation",
    category: "General",
    subCategory: "Outdoors",
  },
  {
    label: "Vegetable farming",
    category: "General",
    subCategory: "Outdoors",
  },
  {
    label: "Videography",
    category: "General",
    subCategory: "Outdoors",
  },
  {
    label: "Vehicle restoration",
    category: "General",
    subCategory: "Outdoors",
  },
  {
    label: "Walking",
    category: "General",
    subCategory: "Outdoors",
  },
  {
    label: "Water sports",
    category: "General",
    subCategory: "Outdoors",
  },
  {
    label: "Astronomy",
    category: "Educational",
    subCategory: false,
  },
  {
    label: "Biology",
    category: "Educational",
    subCategory: false,
  },
  {
    label: "Chemistry",
    category: "Educational",
    subCategory: false,
  },
  {
    label: "Electrochemistry",
    category: "Educational",
    subCategory: false,
  },
  {
    label: "Physics",
    category: "Educational",
    subCategory: false,
  },
  {
    label: "Psychology",
    category: "Educational",
    subCategory: false,
  },
  {
    label: "Sports science",
    category: "Educational",
    subCategory: false,
  },
  {
    label: "Geography",
    category: "Educational",
    subCategory: false,
  },
  {
    label: "History",
    category: "Educational",
    subCategory: false,
  },
  {
    label: "Mathematics",
    category: "Educational",
    subCategory: false,
  },
  {
    label: "Railway studies",
    category: "Educational",
    subCategory: false,
  },
  {
    label: "Action figure",
    category: "Collection",
    subCategory: "Indoors",
  },
  {
    label: "Antiquing",
    category: "Collection",
    subCategory: "Indoors",
  },
  {
    label: "Ant-keeping",
    category: "Collection",
    subCategory: "Indoors",
  },
  {
    label: "Art collecting",
    category: "Collection",
    subCategory: "Indoors",
  },
  {
    label: "Book collecting",
    category: "Collection",
    subCategory: "Indoors",
  },
  {
    label: "Button collecting",
    category: "Collection",
    subCategory: "Indoors",
  },
  {
    label: "Cartophily",
    category: "Collection",
    subCategory: "Indoors",
  },
  {
    label: "Coin collecting",
    category: "Collection",
    subCategory: "Indoors",
  },
  {
    label: "Comic book collecting",
    category: "Collection",
    subCategory: "Indoors",
  },
  {
    label: "Deltiology",
    category: "Collection",
    subCategory: "Indoors",
  },
  {
    label: "Die-cast toy",
    category: "Collection",
    subCategory: "Indoors",
  },
  {
    label: "Digital hoarding",
    category: "Collection",
    subCategory: "Indoors",
  },
  {
    label: "Dolls",
    category: "Collection",
    subCategory: "Indoors",
  },
  {
    label: "Element collecting",
    category: "Collection",
    subCategory: "Indoors",
  },
  {
    label: "Ephemera collecting",
    category: "Collection",
    subCategory: "Indoors",
  },
  {
    label: "Fusilately",
    category: "Collection",
    subCategory: "Indoors",
  },
  {
    label: "Knife collecting",
    category: "Collection",
    subCategory: "Indoors",
  },
  {
    label: "Lotology",
    category: "Collection",
    subCategory: "Indoors",
  },
  {
    label: "Movie and movie memorabilia collecting",
    category: "Collection",
    subCategory: "Indoors",
  },
  {
    label: "Fingerprint collecting",
    category: "Collection",
    subCategory: "Indoors",
  },
  {
    label: "Perfume",
    category: "Collection",
    subCategory: "Indoors",
  },
  {
    label: "Phillumeny",
    category: "Collection",
    subCategory: "Indoors",
  },
  {
    label: "Radio-controlled model",
    category: "Collection",
    subCategory: "Indoors",
  },
  {
    label: "Rail transport modelling",
    category: "Collection",
    subCategory: "Indoors",
  },
  {
    label: "Record collecting",
    category: "Collection",
    subCategory: "Indoors",
  },
  {
    label: "Rock tumbling",
    category: "Collection",
    subCategory: "Indoors",
  },
  {
    label: "Scutelliphily",
    category: "Collection",
    subCategory: "Indoors",
  },
  {
    label: "Shoes",
    category: "Collection",
    subCategory: "Indoors",
  },
  {
    label: "Slot car",
    category: "Collection",
    subCategory: "Indoors",
  },
  {
    label: "Sports memorabilia",
    category: "Collection",
    subCategory: "Indoors",
  },
  {
    label: "Stamp collecting",
    category: "Collection",
    subCategory: "Indoors",
  },
  {
    label: "Stuffed toy collecting",
    category: "Collection",
    subCategory: "Indoors",
  },
  {
    label: "Tea bag collecting",
    category: "Collection",
    subCategory: "Indoors",
  },
  {
    label: "Ticket collecting",
    category: "Collection",
    subCategory: "Indoors",
  },
  {
    label: "Toys",
    category: "Collection",
    subCategory: "Indoors",
  },
  {
    label: "Transit map collecting",
    category: "Collection",
    subCategory: "Indoors",
  },
  {
    label: "Video game collecting",
    category: "Collection",
    subCategory: "Indoors",
  },
  {
    label: "Vintage cars",
    category: "Collection",
    subCategory: "Indoors",
  },
  {
    label: "Vintage clothing",
    category: "Collection",
    subCategory: "Indoors",
  },
  {
    label: "Vinyl Records",
    category: "Collection",
    subCategory: "Indoors",
  },
  {
    label: "Antiquities",
    category: "Collection",
    subCategory: "Outdoors",
  },
  {
    label: "Auto audiophilia",
    category: "Collection",
    subCategory: "Outdoors",
  },
  {
    label: "Flower collecting and pressing",
    category: "Collection",
    subCategory: "Outdoors",
  },
  {
    label: "Fossil hunting",
    category: "Collection",
    subCategory: "Outdoors",
  },
  {
    label: "Insect collecting",
    category: "Collection",
    subCategory: "Outdoors",
  },
  {
    label: "Magnet fishing",
    category: "Collection",
    subCategory: "Outdoors",
  },
  {
    label: "Metal detecting",
    category: "Collection",
    subCategory: "Outdoors",
  },
  {
    label: "Mineral collecting",
    category: "Collection",
    subCategory: "Outdoors",
  },
  {
    label: "Rock balancing",
    category: "Collection",
    subCategory: "Outdoors",
  },
  {
    label: "Sea glass collecting",
    category: "Collection",
    subCategory: "Outdoors",
  },
  {
    label: "Seashell collecting",
    category: "Collection",
    subCategory: "Outdoors",
  },
  {
    label: "Stone collecting",
    category: "Collection",
    subCategory: "Outdoors",
  },
  {
    label: "Animal fancy",
    category: "Competitive",
    subCategory: "Indoors",
  },
  {
    label: "Axe throwing",
    category: "Competitive",
    subCategory: "Indoors",
  },
  {
    label: "Backgammon",
    category: "Competitive",
    subCategory: "Indoors",
  },
  {
    label: "Badminton",
    category: "Competitive",
    subCategory: "Indoors",
  },
  {
    label: "Baton twirling",
    category: "Competitive",
    subCategory: "Indoors",
  },
  {
    label: "Beauty pageants",
    category: "Competitive",
    subCategory: "Indoors",
  },
  {
    label: "Billiards",
    category: "Competitive",
    subCategory: "Indoors",
  },
  {
    label: "Bowling",
    category: "Competitive",
    subCategory: "Indoors",
  },
  {
    label: "Boxing",
    category: "Competitive",
    subCategory: "Indoors",
  },
  {
    label: "Bridge",
    category: "Competitive",
    subCategory: "Indoors",
  },
  {
    label: "Checkers (draughts)",
    category: "Competitive",
    subCategory: "Indoors",
  },
  {
    label: "Cheerleading",
    category: "Competitive",
    subCategory: "Indoors",
  },
  {
    label: "Chess",
    category: "Competitive",
    subCategory: "Indoors",
  },
  {
    label: "Color guard",
    category: "Competitive",
    subCategory: "Indoors",
  },
  {
    label: "Cribbage",
    category: "Competitive",
    subCategory: "Indoors",
  },
  {
    label: "Curling",
    category: "Competitive",
    subCategory: "Indoors",
  },
  {
    label: "Dancing",
    category: "Competitive",
    subCategory: "Indoors",
  },
  {
    label: "Darts",
    category: "Competitive",
    subCategory: "Indoors",
  },
  {
    label: "Debate",
    category: "Competitive",
    subCategory: "Indoors",
  },
  {
    label: "Dominoes",
    category: "Competitive",
    subCategory: "Indoors",
  },
  {
    label: "Eating",
    category: "Competitive",
    subCategory: "Indoors",
  },
  {
    label: "Esports",
    category: "Competitive",
    subCategory: "Indoors",
  },
  {
    label: "Fencing",
    category: "Competitive",
    subCategory: "Indoors",
  },
  {
    label: "Go",
    category: "Competitive",
    subCategory: "Indoors",
  },
  {
    label: "Gymnastics",
    category: "Competitive",
    subCategory: "Indoors",
  },
  {
    label: "Ice hockey",
    category: "Competitive",
    subCategory: "Indoors",
  },
  {
    label: "Ice skating",
    category: "Competitive",
    subCategory: "Indoors",
  },
  {
    label: "Judo",
    category: "Competitive",
    subCategory: "Indoors",
  },
  {
    label: "Jujitsu",
    category: "Competitive",
    subCategory: "Indoors",
  },
  {
    label: "Kabaddi",
    category: "Competitive",
    subCategory: "Indoors",
  },
  {
    label: "Knowledge/word games",
    category: "Competitive",
    subCategory: "Indoors",
  },
  {
    label: "Laser tag",
    category: "Competitive",
    subCategory: "Indoors",
  },
  {
    label: "Longboarding",
    category: "Competitive",
    subCategory: "Indoors",
  },
  {
    label: "Mahjong",
    category: "Competitive",
    subCategory: "Indoors",
  },
  {
    label: "Marbles",
    category: "Competitive",
    subCategory: "Indoors",
  },
  {
    label: "Martial arts",
    category: "Competitive",
    subCategory: "Indoors",
  },
  {
    label: "Model United Nations",
    category: "Competitive",
    subCategory: "Indoors",
  },
  {
    label: "Poker",
    category: "Competitive",
    subCategory: "Indoors",
  },
  {
    label: "Pool",
    category: "Competitive",
    subCategory: "Indoors",
  },
  {
    label: "Role-playing games",
    category: "Competitive",
    subCategory: "Indoors",
  },
  {
    label: "Shogi",
    category: "Competitive",
    subCategory: "Indoors",
  },
  {
    label: "Slot car racing",
    category: "Competitive",
    subCategory: "Indoors",
  },
  {
    label: "Speedcubing",
    category: "Competitive",
    subCategory: "Indoors",
  },
  {
    label: "Sport stacking",
    category: "Competitive",
    subCategory: "Indoors",
  },
  {
    label: "Table football",
    category: "Competitive",
    subCategory: "Indoors",
  },
  {
    label: "Table tennis",
    category: "Competitive",
    subCategory: "Indoors",
  },
  {
    label: "Volleyball",
    category: "Competitive",
    subCategory: "Indoors",
  },
  {
    label: "Weightlifting",
    category: "Competitive",
    subCategory: "Indoors",
  },
  {
    label: "Wrestling",
    category: "Competitive",
    subCategory: "Indoors",
  },
  {
    label: "Airsoft",
    category: "Competitive",
    subCategory: "Outdoors",
  },
  {
    label: "Archery",
    category: "Competitive",
    subCategory: "Outdoors",
  },
  {
    label: "Association football",
    category: "Competitive",
    subCategory: "Outdoors",
  },
  {
    label: "Australian rules football",
    category: "Competitive",
    subCategory: "Outdoors",
  },
  {
    label: "Auto racing",
    category: "Competitive",
    subCategory: "Outdoors",
  },
  {
    label: "Baseball",
    category: "Competitive",
    subCategory: "Outdoors",
  },
  {
    label: "Beach volleyball",
    category: "Competitive",
    subCategory: "Outdoors",
  },
  {
    label: "Breakdancing",
    category: "Competitive",
    subCategory: "Outdoors",
  },
  {
    label: "Climbing",
    category: "Competitive",
    subCategory: "Outdoors",
  },
  {
    label: "Cricket",
    category: "Competitive",
    subCategory: "Outdoors",
  },
  {
    label: "Croquet",
    category: "Competitive",
    subCategory: "Outdoors",
  },
  {
    label: "Cycling",
    category: "Competitive",
    subCategory: "Outdoors",
  },
  {
    label: "Disc golf",
    category: "Competitive",
    subCategory: "Outdoors",
  },
  {
    label: "Dog sport",
    category: "Competitive",
    subCategory: "Outdoors",
  },
  {
    label: "Equestrianism",
    category: "Competitive",
    subCategory: "Outdoors",
  },
  {
    label: "Exhibition drill",
    category: "Competitive",
    subCategory: "Outdoors",
  },
  {
    label: "Field hockey",
    category: "Competitive",
    subCategory: "Outdoors",
  },
  {
    label: "Figure skating",
    category: "Competitive",
    subCategory: "Outdoors",
  },
  {
    label: "Fishing",
    category: "Competitive",
    subCategory: "Outdoors",
  },
  {
    label: "Footbag",
    category: "Competitive",
    subCategory: "Outdoors",
  },
  {
    label: "Frisbee",
    category: "Competitive",
    subCategory: "Outdoors",
  },
  {
    label: "Golfing",
    category: "Competitive",
    subCategory: "Outdoors",
  },
  {
    label: "Handball",
    category: "Competitive",
    subCategory: "Outdoors",
  },
  {
    label: "Horseback riding",
    category: "Competitive",
    subCategory: "Outdoors",
  },
  {
    label: "Horseshoes",
    category: "Competitive",
    subCategory: "Outdoors",
  },
  {
    label: "Iceboat racing",
    category: "Competitive",
    subCategory: "Outdoors",
  },
  {
    label: "Jukskei",
    category: "Competitive",
    subCategory: "Outdoors",
  },
  {
    label: "Kart racing",
    category: "Competitive",
    subCategory: "Outdoors",
  },
  {
    label: "Knife throwing",
    category: "Competitive",
    subCategory: "Outdoors",
  },
  {
    label: "Lacrosse",
    category: "Competitive",
    subCategory: "Outdoors",
  },
  {
    label: "Longboarding",
    category: "Competitive",
    subCategory: "Outdoors",
  },
  {
    label: "Long-distance running",
    category: "Competitive",
    subCategory: "Outdoors",
  },
  {
    label: "Marching band",
    category: "Competitive",
    subCategory: "Outdoors",
  },
  {
    label: "Model aircraft",
    category: "Competitive",
    subCategory: "Outdoors",
  },
  {
    label: "Orienteering",
    category: "Competitive",
    subCategory: "Outdoors",
  },
  {
    label: "Pickleball",
    category: "Competitive",
    subCategory: "Outdoors",
  },
  {
    label: "Quidditch",
    category: "Competitive",
    subCategory: "Outdoors",
  },
  {
    label: "Race walking",
    category: "Competitive",
    subCategory: "Outdoors",
  },
  {
    label: "Racquetball",
    category: "Competitive",
    subCategory: "Outdoors",
  },
  {
    label: "Radio-controlled car racing",
    category: "Competitive",
    subCategory: "Outdoors",
  },
  {
    label: "Roller derby",
    category: "Competitive",
    subCategory: "Outdoors",
  },
  {
    label: "Rugby league football",
    category: "Competitive",
    subCategory: "Outdoors",
  },
  {
    label: "Sculling",
    category: "Competitive",
    subCategory: "Outdoors",
  },
  {
    label: "Shooting sport",
    category: "Competitive",
    subCategory: "Outdoors",
  },
  {
    label: "Skateboarding",
    category: "Competitive",
    subCategory: "Outdoors",
  },
  {
    label: "Skiing",
    category: "Competitive",
    subCategory: "Outdoors",
  },
  {
    label: "Sled dog racing",
    category: "Competitive",
    subCategory: "Outdoors",
  },
  {
    label: "Softball",
    category: "Competitive",
    subCategory: "Outdoors",
  },
  {
    label: "Speed skating",
    category: "Competitive",
    subCategory: "Outdoors",
  },
  {
    label: "Squash",
    category: "Competitive",
    subCategory: "Outdoors",
  },
  {
    label: "Surfing",
    category: "Competitive",
    subCategory: "Outdoors",
  },
  {
    label: "Swimming",
    category: "Competitive",
    subCategory: "Outdoors",
  },
  {
    label: "Table tennis",
    category: "Competitive",
    subCategory: "Outdoors",
  },
  {
    label: "Tennis",
    category: "Competitive",
    subCategory: "Outdoors",
  },
  {
    label: "Tennis polo",
    category: "Competitive",
    subCategory: "Outdoors",
  },
  {
    label: "Tether car",
    category: "Competitive",
    subCategory: "Outdoors",
  },
  {
    label: "Tour skating",
    category: "Competitive",
    subCategory: "Outdoors",
  },
  {
    label: "Tourism",
    category: "Competitive",
    subCategory: "Outdoors",
  },
  {
    label: "Trapshooting",
    category: "Competitive",
    subCategory: "Outdoors",
  },
  {
    label: "Triathlon",
    category: "Competitive",
    subCategory: "Outdoors",
  },
  {
    label: "Ultimate frisbee",
    category: "Competitive",
    subCategory: "Outdoors",
  },
  {
    label: "Volleyball",
    category: "Competitive",
    subCategory: "Outdoors",
  },
  {
    label: "Water polo",
    category: "Competitive",
    subCategory: "Outdoors",
  },
  {
    label: "Fishkeeping",
    category: "Observation",
    subCategory: "Indoors",
  },
  {
    label: "Learning",
    category: "Observation",
    subCategory: "Indoors",
  },
  {
    label: "Meditation",
    category: "Observation",
    subCategory: "Indoors",
  },
  {
    label: "Microscopy",
    category: "Observation",
    subCategory: "Indoors",
  },
  {
    label: "Reading",
    category: "Observation",
    subCategory: "Indoors",
  },
  {
    label: "Research",
    category: "Observation",
    subCategory: "Indoors",
  },
  {
    label: "Shortwave listening",
    category: "Observation",
    subCategory: "Indoors",
  },
  {
    label: "Audiophile",
    category: "Observation",
    subCategory: "Indoors",
  },
  {
    label: "Aircraft spotting",
    category: "Observation",
    subCategory: "Outdoors",
  },
  {
    label: "Amateur astronomy",
    category: "Observation",
    subCategory: "Outdoors",
  },
  {
    label: "Birdwatching",
    category: "Observation",
    subCategory: "Outdoors",
  },
  {
    label: "Bus spotting",
    category: "Observation",
    subCategory: "Outdoors",
  },
  {
    label: "Geocaching",
    category: "Observation",
    subCategory: "Outdoors",
  },
  {
    label: "Gongoozling",
    category: "Observation",
    subCategory: "Outdoors",
  },
  {
    label: "Herping",
    category: "Observation",
    subCategory: "Outdoors",
  },
  {
    label: "Hiking",
    category: "Observation",
    subCategory: "Outdoors",
  },
  {
    label: "Meteorology",
    category: "Observation",
    subCategory: "Outdoors",
  },
  {
    label: "Photography",
    category: "Observation",
    subCategory: "Outdoors",
  },
  {
    label: "Satellite watching",
    category: "Observation",
    subCategory: "Outdoors",
  },
  {
    label: "Trainspotting",
    category: "Observation",
    subCategory: "Outdoors",
  },
  {
    label: "Whale watching",
    category: "Observation",
    subCategory: "Outdoors",
  },
];
